




import { createComponent, ref } from '@vue/composition-api';
import { useStore } from '@/core/store';
import deviceStore from './store';
import DeviceGroup from '@/core/store/types/DeviceGroup';

export default createComponent({
  setup () {
    const store = useStore();

    const loading = ref(!store.getters['entities/DeviceGroup/all']().length);

    store.registerModule('device', deviceStore);
    store.dispatch('getDeviceGroups').then(() => {
      loading.value = false;
    });

    return {
      loading,
    };
  },
});
